import React, { Component } from 'react';
export default class About extends Component {
  render() {
   //  let resumeData = this.props.resumeData;
    return (
      <section id="about" style={{ textAlign: 'center' }}>
         <div className="row">

            <div className="twelve columns">

               <h2>Why Choose Us?</h2>
               <br></br>
               <h3>Expertise in Automation:</h3>
               <p>We specialize in leveraging the power of automation to streamline and optimize your IT operations. Our team of experts is skilled in developing custom automation solutions that save time, reduce errors, and increase efficiency. By automating repetitive tasks, we free up your resources to focus on strategic initiatives and business growth.</p>
               <h3>Custom Solution Building:</h3>
               <p>We understand that every business has unique needs and challenges. That's why we take a personalized approach to solution building. Our team works closely with you to assess your specific requirements and design tailored IT solutions that align with your goals.</p>
               <h3>Hybrid Cloud Security Specialists:</h3>
               <p>Our Approach in security is to secure every surface level. We implement robust security measures, including advanced threat detection and prevention on multiple surface approach, encryption, access controls, and compliance frameworks, to safeguard your valuable assets.</p>
               <h3>Proactive Support and Monitoring:</h3>
               <p>We take a proactive approach to IT support and monitoring. Our custom built systems continuously monitors your systems, identifying and resolving potential issues before they impact your business operations.</p>
               <h3>Customer-Centric Approach:</h3>
               <p>Our priority is customer satisfaction above all else. We strive to build long-term partnerships with our clients by providing exceptional service and support. Our team is responsive, transparent, and committed to delivering results that align with your business objectives.</p>


               <div className="row">

               </div>
            </div>
         </div>
      </section>
    );
  }
}